'use client';

import React, { useState } from 'react';

export const Banner = ({ banner, onClose }) => {
  const [showBox, setShowBox] = useState(true);

  return (
    <>
      {showBox && (
        <div className="bg-[#006EB7] banner-responsive-padding z-20">
          <div className="container mx-auto">
            <button
              onClick={() => { setShowBox(false); onClose?.(); }}
              aria-label="Close banner"
              className="w-4 h-4 ml-auto bg-transparent border-none cursor-pointer p-0 flex items-center justify-center"
            >
              <img
                src="/img/icons/x-close-2.svg"
                alt="close-btn"
                loading="lazy"
                className="w-4 h-4"
              />
            </button>
            <div className="lg:flex lg:gap-4 mt-1">
              <p className="text-[#F3F4F8] text-lg font-semibold mb-1">
                {banner?.banner_title}
              </p>
            </div>
            <div
              className="text-[#F3F4F8] text-[0.9375rem] font-450 mb-4"
              dangerouslySetInnerHTML={{ __html: banner?.banner_content || '' }}
              suppressHydrationWarning={true}
            />

            {banner?.banner_button_url && banner?.banner_button_text && (
              <div className="pointer-events-none">
                <a
                  href={banner.banner_button_url}
                  className="text-[#F3F4F8] text-[0.9375rem] font-semibold plain-text-link--white items-center justify-center md:justify-start gap-2 pointer-events-auto inline-flex focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 rounded"
                  aria-label={`${banner.banner_button_text} (opens in current window)`}
                >
                  {banner.banner_button_text}

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M3.33337 7.99992H12.6667M12.6667 7.99992L8.00004 3.33325M12.6667 7.99992L8.00004 12.6666"
                      stroke="#F3F4F8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
